module.exports = __webpack_public_path__ + "static/img/shdz.f9f800c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shdz.jpg
// module id = VgCF
// module chunks = 4